export const defaultLocalizationData: any = {
  key: '',
  andKey: '',
  value: '',
  languageKey: ''
}
